module.exports = __webpack_public_path__ + "img/verde-sys-big.26dc0458.png";